import * as React from 'react';
import { observer } from 'mobx-react';
import styles from './index.less';
import LinkC from '@src/components/link';
import { Link } from 'react-scroll';

import OfficialCommunity from '@src/business-components/official-community';
import $$tracker from '@src/tracker';
import cx from 'classnames';
/**
 * 移动端游戏顶部导航
 * 如果需要跳转到具体的节点, 需要在需要跳转的部分, 加入
 * <Element name="menuListId" className="new-classic-appointment-part" />
 * menuListId - 对应的节点id, 匹配menuList中的id值
 * @param store
 * @param rest
 * @returns {JSX.Element}
 * @constructor
 */

const TopMenu = ({ store, ...rest }) => {
  store.use();
  console.log('isHideStrategy', store.isHideStrategy);

  return (
    <div className={styles.root}>
      <div className="main-group-55" data-name="顶栏">
        <div className="main-layer-173" />
        <div className="main-group-56" data-name="右边">
          {(store.state === 1 || store.state === 2) && (
            <LinkC className={cx('main-layer-174', 'is-download')} aria-label="立即下载" onClick={store.onDownloadClick} />
          )}
          {store.state === 3 && (
            <LinkC
              className="main-layer-174"
              aria-label="立即预约"
              onClick={() => {
                store.onAppointmentClick();
                $$tracker.clickToReserveGame('顶部通栏');
              }}
            />
          )}

          <LinkC
            className="main-layer-175"
            onClick={() => {
              store.onchangeMenu(!store.menuState);
            }}
          />
        </div>

        <div className="main-group-57" data-name="左边">
          <div className="main-layer-176" />
          <div className="main-layer-177" />
        </div>
      </div>

      {store.menuState && (
        <div className="main-group-58" data-name=" H5导航二">
          <div className="main-layer-178" />
          <div className={cx('main-group-59', store.isHideStrategy && 'hide-strategy')} data-name="导航列表">
            <Link
              className="main-layer-179"
              onClick={() => {
                store.onClickRightNav('江湖快报', 'news');
                store.onchangeMenu(!store.menuState);
              }}
              to={'news'}
              spy={true}
              offset={-34}
              smooth={true}
              duration={200}
            />
            <Link
              className="main-layer-180"
              onClick={() => {
                store.onClickRightNav('游戏特色', 'feature');
                store.onchangeMenu(!store.menuState);
              }}
              to={'feature'}
              spy={true}
              smooth={true}
              duration={200}
            />
            <Link
              className="main-layer-181"
              onClick={() => {
                store.onClickRightNav('门派', 'school');
                store.onchangeMenu(!store.menuState);
              }}
              to={'school'}
              spy={true}
              smooth={true}
              duration={200}
            />
            <Link
              className="main-layer-182"
              onClick={() => {
                store.onClickRightNav('攻略', 'data');
                store.onchangeMenu(!store.menuState);
              }}
              to={'data'}
              spy={true}
              offset={-120}
              smooth={true}
              duration={200}
            />
            <Link
              className="main-layer-183"
              onClick={() => {
                store.onClickRightNav('视听中心', 'media');
                store.onchangeMenu(!store.menuState);
              }}
              to={'media'}
              spy={true}
              smooth={true}
              duration={200}
            />
            <LinkC
              className="main-layer-184"
              onClick={() => {
                store.onChangeOfficialListState(true);
                $$tracker.clickTopNav('关注我们');
              }}
              // to={tab.id}
              // spy={true}
              // smooth={true}
              // duration={200}
            />

            {store.officialListState && <OfficialCommunity store={store.officialCommunityStore} />}
          </div>

          <div className="main-group-62" data-name="logo组">
            <div className="main-layer-191" />
            <div className="main-layer-192" />
            <div className="main-layer-193" />
          </div>

          <LinkC
            className="main-layer-194"
            onClick={() => {
              store.onchangeMenu(!store.menuState);
            }}
          />
        </div>
      )}

      {/*<div className={cx(styles.menuContent, store.menuState ? styles.menuAct : '')} data-name="下拉导航">*/}
      {/*  <div className={styles.menuTabList}>*/}
      {/*    {store.menuList?.map(tab => {*/}
      {/*      return (*/}
      {/*        <Link*/}
      {/*          key={`topMenu-${tab.id}`}*/}
      {/*          className={cx(styles.topMenuText)}*/}
      {/*          onClick={() => {*/}
      {/*            store.onClickRightNav(tab.name);*/}
      {/*            store.onchangeMenu(!store.menuState);*/}
      {/*          }}*/}
      {/*          to={tab.id}*/}
      {/*          spy={true}*/}
      {/*          smooth={true}*/}
      {/*          duration={200}*/}
      {/*        >*/}
      {/*          {tab.name}*/}
      {/*        </Link>*/}
      {/*      );*/}
      {/*    })}*/}
      {/*  </div>*/}
      {/*</div>*/}
    </div>
  );
};

export default observer(TopMenu);
